export const PAGE_SIZE = 50;

export const CSV_DOWNLOAD_LABEL = "CSV herunterladen";
